/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getBellCurveReportByAppraisalYear
// GETBELLCURVEREPORTBYAPPRAISALYEAR

const GETBELLCURVEREPORTBYAPPRAISALYEAR= createAsyncThunk(
  "getBellCurveReportByAppraisalYear/getBellCurveReportByAppraisalYear",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getBellCurveReportByAppraisalYearSlice = createSlice({
  name: "getBellCurveReportByAppraisalYearSlice",
  initialState: {
    getBellCurveReportByAppraisalYear: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetBellCurveReportByAppraisalYear: (state) => {
        state.getBellCurveReportByAppraisalYear.loading = false
        state.getBellCurveReportByAppraisalYear.error = false
        state.getBellCurveReportByAppraisalYear.data = []
        state.getBellCurveReportByAppraisalYear.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETBELLCURVEREPORTBYAPPRAISALYEAR.fulfilled, (state, action) => {
      state.getBellCurveReportByAppraisalYear = {
        ...state.getBellCurveReportByAppraisalYear,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETBELLCURVEREPORTBYAPPRAISALYEAR.pending, (state, action) => {
      state.getBellCurveReportByAppraisalYear = {
        ...state.getBellCurveReportByAppraisalYear,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETBELLCURVEREPORTBYAPPRAISALYEAR.rejected, (state, action) => {
      state.getBellCurveReportByAppraisalYear = {
        ...state.getBellCurveReportByAppraisalYear,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getBellCurveReportByAppraisalYearAction = {
    GETBELLCURVEREPORTBYAPPRAISALYEAR,
};

export { getBellCurveReportByAppraisalYearAction };
export default getBellCurveReportByAppraisalYearSlice.reducer;
export const {setInitialStateOfgetBellCurveReportByAppraisalYear} = getBellCurveReportByAppraisalYearSlice.actions